export default function normalizeDate(date) {
    return date || new Date();
}
